import { render, staticRenderFns } from "./SummitQuizEditor.vue?vue&type=template&id=17d64400&"
import script from "./SummitQuizEditor.vue?vue&type=script&lang=ts&"
export * from "./SummitQuizEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports